import { FeatureFlagsLocalStorageEnum } from "./FeatureFlagsLocalStorage.enum";

export class FeatureFlagLocalStorageManager {
    private static STORAGE_KEY = "featureFlags";

    static getFlags(): Record<string, boolean> {
        const flags = localStorage.getItem(this.STORAGE_KEY);
        return flags ? JSON.parse(flags) : {};
    }

    static setFlag(flag: FeatureFlagsLocalStorageEnum, value: boolean) {
        const flags = this.getFlags();
        flags[flag] = value;
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(flags));
    }

    static getFlag(flag: FeatureFlagsLocalStorageEnum): boolean | undefined {
        return this.getFlags()[flag];
    }

    static initializeFromQueryParams() {
        const params = new URLSearchParams(window.location.search);
        let updated = false;

        params.forEach((value, key) => {
            if (
                Object.values(FeatureFlagsLocalStorageEnum).includes(
                    key as FeatureFlagsLocalStorageEnum,
                ) &&
                (value === "true" || value === "false")
            ) {
                this.setFlag(
                    key as FeatureFlagsLocalStorageEnum,
                    value === "true",
                );
                updated = true;
            }
        });

        if (updated) {
            window.location.href = window.location.pathname; // Clears query params
        }
    }
}
